// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"58c29bcd","328":"c1686f8a","453":"6cf966eb","702":"0028e826","737":"2b5a146c","807":"d74b52d2","900":"089e98ad"}[chunkId] + ".chunk.js";
};